import { DisposalSet } from '../../../utils';
import { registerFragment } from '../../registry';
import './styles.scss';
const gc = new DisposalSet();
registerFragment('ntp-conditional-content', (fragEl, config, meta) => {});
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
  import.meta.webpackHot.dispose(() => gc.disposeAll());
}